// extracted by mini-css-extract-plugin
export default {"gift-icon":"_3gFFO","giftIcon":"_3gFFO","wiggle":"_30w_c"};